import jwt_decode, { JwtPayload } from "jwt-decode";
import { useState } from "react";
import useLocalStorageState from "use-local-storage-state";
import constate from "constate";
import { Field } from "./components/common/form/FieldHandler";

export interface PianoJWTDatabase {
  name: string;
  role: "admin" | "member" | "visitor";
  project?: {
    name: string;
    role: "admin" | "member" | "visitor";
    inventory?: { name: string; role: "admin" | "member" | "visitor" }[];
  }[];
}
interface PianoJWT extends JwtPayload {
  userId: string;
  db: (string | PianoJWTDatabase)[];
}

export interface FilterItem {
  form: {
    key: string;
    fields: Record<string, { type: "dropdown" | "combobox" | string }>;
  };
  values: Record<string, Field["value"]>;
  valueKeys: string[];
  key: string;
}

function useApplicationState() {
  const [jwt, setJWT] = useLocalStorageState<string | null>("piano-jwt", { defaultValue: null });
  const [lastInventoryId, setLastInventoryId] = useLocalStorageState<string | null>("piano-lastInventoryId", { defaultValue: null });
  const [offlineMapId, setOfflineMapId] = useLocalStorageState<number | null>("piano-offlineMapId", { defaultValue: null });

  const [mapClickEnabled, setMapClickEnabled] = useState(true);
  const [layerClickActive, setLayerClickActive] = useState(false);
  const [filterItem, setFilterItem] = useState<null | FilterItem>(null);

  return {
    jwt,
    setJWT,
    lastInventoryId,
    setLastInventoryId,
    mapClickEnabled,
    setMapClickEnabled,
    layerClickActive,
    setLayerClickActive,
    filterItem,
    setFilterItem,
    offlineMapId,
    setOfflineMapId,
  };
}
const [
  ApplicationStateProvider,
  useJWT,
  useRawJWT,
  useSetJWT,
  useLastInventoryId,
  useSetLastInventoryId,
  useMapClickEnabled,
  useSetMapClickEnabled,
  useLayerClickActive,
  useToggleLayerClickActive,
  useFilterItem,
  useSetFilterItem,
  useOfflineMapId,
  useSetOfflineMapId,
] = constate(
  useApplicationState,
  (s) => (s.jwt ? jwt_decode<PianoJWT>(s.jwt) : undefined),
  (s) => s.jwt,
  (s) => s.setJWT,
  (s) => s.lastInventoryId,
  (s) => s.setLastInventoryId,
  (s) => s.mapClickEnabled,
  (s) => s.setMapClickEnabled,
  (s) => s.layerClickActive,
  (s) => () => s.setLayerClickActive((v) => !v),
  (s) => s.filterItem,
  (s) => s.setFilterItem,
  (s) => s.offlineMapId,
  (s) => s.setOfflineMapId
);

export {
  ApplicationStateProvider,
  useJWT,
  useRawJWT,
  useSetJWT,
  useLastInventoryId,
  useSetLastInventoryId,
  useMapClickEnabled,
  useSetMapClickEnabled,
  useLayerClickActive,
  useToggleLayerClickActive,
  useFilterItem,
  useSetFilterItem,
  useOfflineMapId,
  useSetOfflineMapId,
};
